import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import WithBackground from '../Common/WithBackground';

import './style.css';

const AddressBlock = ({ bg, overlay }) => {
  const { t } = useTranslation();

  const addressContent = (
    <section className='AddressBlock'>
      <div className='AddressBlock__container'>
        <div className='AddressBlock__header'>
          <h2
            className='AddressBlock__title'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {t('addressBlock.title')}
          </h2>
        </div>

        <div className='AddressBlock__content'>
          <div
            className='AddressBlock__map'
            data-aos='fade-right'
            data-aos-delay='200'
          >
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.6789!2d15.578!3d52.4435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zQ2jFgm9kbmEgMTVhLzcsIDY2LTMwMCBNacSZZHp5cnplY3o!5e0!3m2!1spl!2spl!4v1234567890'
              width='100%'
              height='400'
              style={{ border: 0 }}
              allowFullScreen=''
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
              title={t('addressBlock.mapTitle')}
            ></iframe>
          </div>

          <div
            className='AddressBlock__info'
            data-aos='fade-left'
            data-aos-delay='200'
          >
            <div className='AddressBlock__card'>
              <h3 className='AddressBlock__card-title'>
                {t('addressBlock.mainOffice.name')}
              </h3>
              <div className='AddressBlock__card-content'>
                <div className='AddressBlock__detail'>
                  <span className='AddressBlock__label'>
                    {t('addressBlock.labels.address')}:
                  </span>
                  <span className='AddressBlock__value'>
                    {t('addressBlock.mainOffice.street')}
                  </span>
                  <span className='AddressBlock__value'>
                    {t('addressBlock.mainOffice.city')}
                  </span>
                </div>
                <div className='AddressBlock__detail'>
                  <span className='AddressBlock__label'>
                    {t('addressBlock.labels.phone')}:
                  </span>
                  <span className='AddressBlock__value'>
                    {t('addressBlock.mainOffice.phone')}
                  </span>
                </div>
                <div className='AddressBlock__detail'>
                  <span className='AddressBlock__label'>
                    {t('addressBlock.labels.email')}:
                  </span>
                  <span className='AddressBlock__value'>
                    {t('addressBlock.mainOffice.email')}
                  </span>
                </div>
                <div className='AddressBlock__detail'>
                  <span className='AddressBlock__label'>
                    {t('addressBlock.labels.nip')}:
                  </span>
                  <span className='AddressBlock__value'>
                    {t('addressBlock.mainOffice.nip')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {addressContent}
    </WithBackground>
  ) : (
    addressContent
  );
};

AddressBlock.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

AddressBlock.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default AddressBlock;
